import { Component, OnInit } from '@angular/core';
import { EditDynamicAsset } from '../../../models/inModels/DynamicAsset';
import { Message } from 'primeng/primeng';
import { ActivatedRoute, Router } from '@angular/router';
import { AssetService } from '../../../services/asset.service';
import { StorageService } from '../../../services/system/storage.service';

@Component({
  selector: 'app-edit-asset',
  templateUrl: './edit-asset.component.html',
  styleUrls: ['./edit-asset.component.css']
})
export class EditAssetComponent implements OnInit {
  id;
  model: EditDynamicAsset;
  loading = false;
  error: Message[];
  uploading = false;
  asset;
  constructor(
    private route: ActivatedRoute,
		private router: Router,
		private service: AssetService,
		private storageService: StorageService
  ) { 
    this.id = this.route.snapshot.paramMap.get('Id');
  }

  ngOnInit() {

    this.getAsset();
  }

  getAsset() {
    this.loading = true;
    this.service.get(this.id).then(
			result => {
				this.model = new EditDynamicAsset(result);
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
  }

  goBack(): void {
		this.router.navigate(['/assets']);
  }

  save() {
		this.loading = true;
		this.service.update(this.model).then(
			result => {
				this.loading = false;
				this.model = new EditDynamicAsset(result);
				this.error = [];
				this.error.push({ severity: 'success', summary: 'Success', detail: "Event saved" });
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
  }

  handleWebImage(event): void {
		var result = this.storageService.handleSuccess(event);

		this.model.WebPictureId = result.PublicId;
		this.loading = false;
	}

  removeWebImage(): void {
		this.model.WebPictureId = null;
		this.loading = false;
	}

  handleMobileImage(event): void {
		var result = this.storageService.handleSuccess(event);

		this.model.MobilePictureId = result.PublicId;
		this.loading = false;
	}

  removeMobileImage(): void {
		this.model.MobilePictureId = null;
		this.loading = false;
	}

  handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/asset/edit-asset/edit-asset.component.ts